import { render, staticRenderFns } from "./FranchiseUsers.vue?vue&type=template&id=219f6b18&scoped=true"
import script from "./FranchiseUsers.vue?vue&type=script&lang=js"
export * from "./FranchiseUsers.vue?vue&type=script&lang=js"
import style0 from "./FranchiseUsers.vue?vue&type=style&index=0&id=219f6b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219f6b18",
  null
  
)

export default component.exports